// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminSendSso Styling - passt zu einem modernen Look wie das Getränke-Archiv */

.admin-container {
    max-width: 600px;
    margin: 50px auto;
    text-align: center;
  }
  
  .admin-heading {
    font-size: 24px;
    margin-bottom: 20px;
    color: white;
  }
  
  .admin-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .admin-label {
    font-size: 16px;
    margin-bottom: 10px;
    width: 100%;
    text-align: left;
    color: white;
  }
  
  .admin-input {
    width: 100%;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
    border: 1px solid #ccc;
    color: white;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s ease;
  }
  
  .admin-input:focus {
    border-color: black;
  }
  
  .admin-btn {
    padding: 10px 20px;
    font-size: 16px;
    background-color: black;
    color: white;
    border-color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .admin-btn:hover {
    background-color: #a0a0a0;
  }
  
  .admin-message {
    margin-top: 20px;
    color: #28a745;
    font-size: 16px;
  }
  
  /* Optional responsive styling */
  @media (max-width: 768px) {
    .admin-container {
      margin: 20px;
      padding: 20px;
    }
    
    .admin-heading {
      font-size: 20px;
    }
  
    .admin-input {
      font-size: 14px;
    }
  
    .admin-btn {
      font-size: 14px;
      padding: 8px 16px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/private/Admin/AdminSendSso.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;EACF","sourcesContent":["/* AdminSendSso Styling - passt zu einem modernen Look wie das Getränke-Archiv */\r\n\r\n.admin-container {\r\n    max-width: 600px;\r\n    margin: 50px auto;\r\n    text-align: center;\r\n  }\r\n  \r\n  .admin-heading {\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n    color: white;\r\n  }\r\n  \r\n  .admin-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  \r\n  .admin-label {\r\n    font-size: 16px;\r\n    margin-bottom: 10px;\r\n    width: 100%;\r\n    text-align: left;\r\n    color: white;\r\n  }\r\n  \r\n  .admin-input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    border-radius: 5px;\r\n    border: 1px solid #ccc;\r\n    color: white;\r\n    font-size: 16px;\r\n    outline: none;\r\n    transition: border-color 0.3s ease;\r\n  }\r\n  \r\n  .admin-input:focus {\r\n    border-color: black;\r\n  }\r\n  \r\n  .admin-btn {\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    background-color: black;\r\n    color: white;\r\n    border-color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .admin-btn:hover {\r\n    background-color: #a0a0a0;\r\n  }\r\n  \r\n  .admin-message {\r\n    margin-top: 20px;\r\n    color: #28a745;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  /* Optional responsive styling */\r\n  @media (max-width: 768px) {\r\n    .admin-container {\r\n      margin: 20px;\r\n      padding: 20px;\r\n    }\r\n    \r\n    .admin-heading {\r\n      font-size: 20px;\r\n    }\r\n  \r\n    .admin-input {\r\n      font-size: 14px;\r\n    }\r\n  \r\n    .admin-btn {\r\n      font-size: 14px;\r\n      padding: 8px 16px;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
